export const BROKERS_PLACEHOLDER = 'broker1:9092,broker2:9092,broker3:9092';
export const TABLE_OVERRIDES_PLACEHOLDER = `identify: identify
page: page
order_completed: order_completed`;
export const FIELD_OVERRIDES_PLACEHOLDER = `- table: my_table
  field: my_field
  fieldType: BIG_QUERY_FIELD_TYPE_TIMESTAMP`;
export const PARTITIONING_PLACEHOLDER = `granularity: BIG_QUERY_PARTITION_GRANULARITY_DAILY
partitionField: received_at
expirationDays: 0
events:
  - eventName: page
  - eventName: product_*
    tableOverride: "{event}_daily"`;
